import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Layout from './layouts/Layout';

import 'react-toastify/dist/ReactToastify.min.css';
import './assets/scss/_user.scss';
import './assets/scss/_padmin.scss';

const App = () => {
  return (
    <Router>
      <Layout />
    </Router>
  );
};

export default App;
